import { render, staticRenderFns } from "./ProductUpstreamTransportationByPartner.vue?vue&type=template&id=04131196"
import script from "./ProductUpstreamTransportationByPartner.vue?vue&type=script&lang=js"
export * from "./ProductUpstreamTransportationByPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports